import React from "react";
import AboutBackground from "../Assets/about-background.png";
import AboutBackgroundImage from "../Assets/about-background-image.png";
import { BsFillPlayCircleFill } from "react-icons/bs";

const About = () => {
  return (
    <div className="about-section-container">
      <div className="about-background-image-container">
        <img src={AboutBackground} alt="" />
      </div>
      <div className="about-section-image-container">
        <img src={AboutBackgroundImage} alt="" />
      </div>
      <div className="about-section-text-container">
        <p className="primary-subheading">About</p>
        <h1 className="primary-heading">
          Food is an important part of a balanced diet
        </h1>
        <p className="primary-text">
          A healthy and balanced lifestyle requires a nutritious diet and regular exercise. <span className="changeColor">Food is essential to fueling workouts and maximizing fitness results</span>. To get all the necessary vitamins and minerals, consume a variety of whole grains, lean proteins, fruits, and vegetables. Adequate hydration is also critical; drink plenty of water before, during, and after exercise. 
        </p>
        <a href="https://www.youtube.com/watch?v=xyQY8a-ng6g" rel="noreferrer" target="_blank">
        <div className="about-buttons-container">
          <button className="secondary-button">Learn More</button>
          <button className="watch-video-button">
            <BsFillPlayCircleFill /> Watch Video
          </button>
        </div>
        </a>
      </div>
    </div>
  );
};

export default About;
